import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(HttpBackend) // Load translations from backend files    
    .use(I18nextBrowserLanguageDetector)
    .use(initReactI18next) // Pass i18n instance to react-i18next
    .init({
        fallbackLng: 'ru',
        supportedLngs: ['ru'],
        lng: localStorage.getItem('i18nextLng') || 'kz', // Принудительно ставим 'kz' при первой загрузке
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        detection: {
            order: ["localStorage"]
        },
        interpolation: {
            escapeValue: false, // React already escapes values
        },
        react: {
            useSuspense: true,
        },
    });

export default i18n;
